module.exports = __webpack_public_path__ + "static/img/page7_img5.d4bcd4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/page7_img5.jpg
// module id = jMP6
// module chunks = 1